import {FormElementValues} from "@xal3xfx/react-utils";
import {timezoneOptions} from "../../../../lib/timezones"

const username: FormElementValues<'text'> = {
    type: "text",
    label: 'username',
    props: {},
}

const password: FormElementValues<'text'> = {
    type: "text",
    label: 'password',
    props: {},
}

const locationTag: FormElementValues<'text'> = {
    type: "text",
    label: 'locationTag',
    props: {},
}

const enableExtraOptions: FormElementValues<'dropdown'> = {
    type: "dropdown",
    label: 'enableExtraOptions',
    props: {},
    options: [
        {key: 1, description: "Yes", id: true},
        {key: 0, description: "No", id: false}
    ]
}


export const formElements = {
    username, password, locationTag, enableExtraOptions
}
